import RecoverStep from "../recover_step";
import axios from "../../../../axios-instance";
import cookies from "js-cookie";

const TEMPLATE = 'select-restore-point';

export default class SelectRestorePoint extends RecoverStep {

  constructor() {
    super(TEMPLATE);
    this.setDefaultFields();
    this.currentMachineId = null;
  }

  setDefaultFields() {
    const currentDate = new Date();
    this.cuurentYear = currentDate.getFullYear();
    this.currentMonth = currentDate.getMonth() + 1;
    this.restorePoints = {};
  }

  open(data, el, fr, previousStep) {
    data.render = {readyToRender: false};
    if (data.recovery.openRpCalendarAfterReloadData || this.currentMachineId !== data.recovery.machineId) {
      this.currentMachineId = data.recovery.machineId;
      data.recovery.openRpCalendarAfterReloadData = false;
      cookies.remove('ftps-export-restore-points-offset');
      data.recovery.restorePoint = null;
      this.setDefaultFields();
      this.removeUrlDateQuery();
      this.loadRestorePointsInCurrentMonth(data, fr, true);
    }
    else {
      setTimeout(() => {
        this.loadRestorePointsInCurrentMonth(data, fr);
      }, 1);
    }
  }

  transitionBack(data, el, fr) {
    fr.goTo('rbSetDevice');
  }

  transitionRecover(data, el, fr) {
    fr.goTo('recoveryInProgress');
  }

  removeUrlDateQuery() {
    const url = new URL(window.location.href);
    url.searchParams.delete('date');
    window.history.replaceState(null, null, url)
  }

  loadRestorePointsInCurrentMonth(data, fr, setCurrentDate = false) {
    const monthKey = `${this.cuurentYear}-${this.currentMonth}`;
    if (this.restorePoints[monthKey]) {
      data.render.readyToRender = true;
      fr.render();
      this.initCalendar(data, fr, this.restorePoints[monthKey]['days'], this.restorePoints[monthKey]['restorePoints'], setCurrentDate);
    } else {
      axios.get(`/ftps_export/get_rb_device_restore_points/${data.recovery.machineId}/${this.cuurentYear}/${this.currentMonth}`).then(response => {
        const responseData = response.data;
        this.restorePoints[monthKey] = {
          'days': responseData.days,
          'restorePoints': responseData.restorePoints
        };
        cookies.set('ftps-export-restore-points-offset', responseData['newOffset']);
        data.render.readyToRender = true;
        fr.render();
        this.initCalendar(data, fr, responseData.days, responseData.restorePoints, setCurrentDate);
      });
    }
  }

  initCalendar(data, fr, activeDays, restorePoints, setCurrentDate) {
    const calendar = document.getElementById('rb-recovery-flow-select-day');
    const recoveryButton = document.getElementById('recovery-select-rp-next');
    const selectRP = document.getElementById('rb-recovery-flow-select-rp');
    const noRPText = document.querySelector(`.select-rp-no-rp-text`);
    calendar.reports = activeDays;
    calendar.shouldDisableDays = true;
    calendar.hideYearNav = true;
    if (setCurrentDate) {
      const currentDate = new Date();
      const month = ("0" + (currentDate.getMonth() + 1)).slice(-2);
      const day = ("0" + currentDate.getDate()).slice(-2);
      calendar.date = `${currentDate.getFullYear()}-${month}-${day}`;
      const currentDay = currentDate.getDate();

      if (restorePoints[currentDay]) {
        selectRP.classList.remove('invisible');
        noRPText.classList.add('invisible');
        selectRP.options = restorePoints[currentDay];

        if (restorePoints[currentDay].length === 1) {
          data.recovery.restorePoint = restorePoints[currentDay][0].value;
          data.recovery.restorePointLabel = restorePoints[currentDay][0].label;
          recoveryButton.disabled = restorePoints[currentDay][0].disabled;
        }
      }
    }

    calendar.addEventListener('axsCalendarDayChanged', (event) => {
      const currentDate = new Date(`${event.detail}T00:00:00`);
      const currentDay = currentDate.getDate();
      this.cuurentYear = currentDate.getFullYear();
      this.currentMonth = currentDate.getMonth() + 1;
      recoveryButton.disabled = true;

      if (restorePoints[currentDay]) {
        selectRP.classList.remove('invisible');
        noRPText.classList.add('invisible');
        selectRP.options = restorePoints[currentDay];
        if (restorePoints[currentDay].length === 1) {
          data.recovery.restorePoint = restorePoints[currentDay][0].value;
          data.recovery.restorePointLabel = restorePoints[currentDay][0].label;
          recoveryButton.disabled = restorePoints[currentDay][0].disabled;
        }
      } else {
        selectRP.classList.add('invisible');
        noRPText.classList.remove('invisible');
      }
    });

    calendar.addEventListener('axsCalendarMonthChanged', (event) => {
      data.render.readyToRender = false;
      fr.render();
      this.loadRestorePointsInCurrentMonth(data, fr);
    });

    selectRP.addEventListener('change', (event) => {
      const selectedRP = event.target.options[event.target.selectedIndex].value;
      if (selectedRP !== '0') {
        data.recovery.restorePoint = selectedRP;
        data.recovery.restorePointLabel = event.target.options[event.target.selectedIndex].text;
        recoveryButton.disabled = false;
      }
    });
  }
}
